import React, { useState, useEffect } from "react";
import styles from "./TopRefinement.module.scss";
import {
  useInstantSearch,
} from "react-instantsearch";
import Text from "components/text/Text";
import strings from "assets/strings";
import {
  DOCTORS,
  DOCTORS_SORT,
  // LeumitDoctor,
} from "assets/constants";
import { BubbleIcon } from "components/bubbleIcon/BubbleIcon";
import { getAllClassNames, checkIfParamExist, getParams, sanitizeString } from "helpers";
import { CustomToggleRefinement } from "./CustomToggleRefinement";
import { CustomSortBy } from "components/customSortBy/CustomSortBy";


interface TopRefinementProps {
  // isLeumit: boolean;
  isRes: any[];
  objectType: string
  setIsLeumit: React.Dispatch<React.SetStateAction<boolean>>;
  setCurrentSortBy: React.Dispatch<React.SetStateAction<string>>;
}

const CustomStats = ({ includeMashlim }: { includeMashlim: boolean }) => {
  const { scopedResults, results } = useInstantSearch();
  const [doctorsHits, setDoctorsHits] = useState(0);
  useEffect(() => {
    if (!scopedResults) return;
    if (!results || results.__isArtificial) return;
    const doctorsIndex = scopedResults.filter(i => i.indexId === 'DOCTORS_INDEX');
    const exactIndex = scopedResults.filter(i => i.indexId === 'exact');
    const geoIndex = scopedResults.filter(i => i.indexId === 'geo');
    if (exactIndex.length) {
      if (includeMashlim) {
        let totalResults = (exactIndex[0]?.results?._rawResults[exactIndex[0]?.results?._rawResults?.length - 1]?.facets?.type?.ExternalDoctor ?? 0) + (exactIndex[0]?.results?._rawResults[exactIndex[0]?.results?._rawResults?.length - 1]?.facets?.type?.LeumitDoctor ?? 0);
        if (geoIndex) {
          totalResults += (geoIndex[0]?.results?._rawResults[geoIndex[0]?.results?._rawResults?.length - 1]?.facets?.type?.ExternalDoctor ?? 0) + (geoIndex[0]?.results?._rawResults[geoIndex[0]?.results?._rawResults?.length - 1]?.facets?.type?.LeumitDoctor ?? 0);
        }
        setDoctorsHits(totalResults || 0);
      }
      else {
        let totalResults = (exactIndex[0]?.results?.nbHits ?? 0);
        if (geoIndex) {
          totalResults += (geoIndex[0]?.results?.nbHits ?? 0);
        }
        setDoctorsHits(totalResults || 0);
      }
    } else {
      if (includeMashlim) {
        let totalResults = (doctorsIndex[0]?.results?._rawResults[doctorsIndex[0]?.results?._rawResults?.length - 1]?.facets?.type?.ExternalDoctor ?? 0) + (doctorsIndex[0]?.results?._rawResults[doctorsIndex[0]?.results?._rawResults?.length - 1]?.facets?.type?.LeumitDoctor ?? 0);
        setDoctorsHits(totalResults || 0);
      }
      else {
        let totalResults = (doctorsIndex[0]?.results?.nbHits ?? 0);
        setDoctorsHits(totalResults || 0);
      }
    }
  }, [results]);

  return (
    doctorsHits === 0 ? null :
    doctorsHits === 1 ? 
    <Text
      className={styles.title}
      text={strings.globalStrings.foundOneResult} /> :
    <Text
      className={styles.title}
      text={`${strings.doctorSearchResults.found} ${doctorsHits} ${strings.doctorSearchResults.results}`} />
  );
};

export const TopRefinement: React.FC<TopRefinementProps> = ({ setIsLeumit, /*isRes,*/ objectType, setCurrentSortBy /*isLeumit */ }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

  const handleResize = () => {
    setIsMobile(window.innerWidth < 992);
  };

  useEffect(() => {
    // Set up the event listener
    window.addEventListener('resize', handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className={getAllClassNames([styles.container])}>
      <div className={styles.divResults}>
        {Number(objectType) === 1 ? <CustomStats includeMashlim={true} /> : <CustomStats includeMashlim={false} />}
        {(!isMobile && checkIfParamExist('loc')) && <><Text
          className={styles.text}
          text={`${strings.globalStrings.sortBy}`} />
          <CustomSortBy
            items={[
              { label: "שם", value: DOCTORS },
              { label: "מרחק", value: DOCTORS_SORT },
            ]} 
            onRefine={setCurrentSortBy}/></>
        }

      </div>
      {checkIfParamExist('medicalFieldName') && <Text text={`${strings.doctorSearchResults.resultsForSearchedMedicalField} ${sanitizeString(getParams(['medicalFieldName'])[0])}`} className={styles.medicalTitle} />}
      {Number(objectType) === 1 && <div className={styles.divBottom}>
        <CustomToggleRefinement
          attribute="type"
          setIsLeumit={setIsLeumit}
        />

        {!isMobile && <BubbleIcon
          isPopup
          popupTitle={strings.doctorSearchResults.tooltipTitle}
          popupContent={strings.doctorSearchResults.tooltipContent}
          className={styles.bubbleIcon}
          text={strings.globalStrings.whatIsThis}
          info={strings.doctorSearchResults.arrangementRefundInfo}
        />}
      </div>
      }
    </div>
  );
};